import React from 'react'

export default function LoaderWindow({ show = true }) {
  return (
    <>
     {
        show ?
            <div className="loader-window">
                <div>Cargando espere...</div>
            </div>
        : 
        null 
     }
    </>
  )
}